import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";
import { SITE } from "@/lib/site";

const ContactPage = () => {
  return (
    <main data-testid="page-contact">
      <PageHero
        eyebrow="Book a free assessment"
        title="Let's talk about what your family needs."
        subtitle="A senior member of our team will call you back at a time that suits — listen first, then explain what's possible. No pressure, no salespeople."
        ctaTo="#enquiry-form"
        ctaLabel="Go to enquiry form"
      />

      <section className="section">
        <div className="container-px max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="eyebrow">Reach us directly</span>
            <h2 className="font-display text-4xl md:text-5xl mt-4 text-[var(--ss-teal-800)]">
              Quickest way to reach us is a phone call.
            </h2>
            <p className="mt-4 text-[var(--ss-ink-soft)]">
              Our care line is answered by a real person, 24 hours a day. If
              your situation is urgent, please don't hesitate to call.
            </p>

            <div className="mt-8 grid gap-4">
              <a href={SITE.phoneHref} className="card-soft flex items-center gap-4" data-testid="contact-phone">
                <span className="w-12 h-12 rounded-full bg-[var(--ss-teal-700)] text-[var(--ss-cream)] flex items-center justify-center text-lg">
                  <i className="fa-solid fa-phone"></i>
                </span>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--ss-ink-soft)]">
                    Care line · 24/7
                  </div>
                  <div className="font-serif text-3xl text-[var(--ss-teal-800)]">{SITE.phone}</div>
                </div>
              </a>
              <a href={SITE.emailHref} className="card-soft flex items-center gap-4" data-testid="contact-email">
                <span className="w-12 h-12 rounded-full bg-[var(--ss-teal-700)] text-[var(--ss-cream)] flex items-center justify-center text-lg">
                  <i className="fa-regular fa-envelope"></i>
                </span>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--ss-ink-soft)]">
                    Email
                  </div>
                  <div className="text-xl text-[var(--ss-teal-800)]">{SITE.email}</div>
                </div>
              </a>
              <div className="card-soft flex items-start gap-4">
                <span className="w-12 h-12 rounded-full bg-[var(--ss-teal-700)] text-[var(--ss-cream)] flex items-center justify-center text-lg">
                  <i className="fa-solid fa-location-dot"></i>
                </span>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--ss-ink-soft)]">
                    Where we work
                  </div>
                  <div className="text-[var(--ss-teal-800)] mt-1">
                    Epping Forest &amp; Harlow<br />
                    Essex, United Kingdom
                  </div>
                  <div className="text-xs text-[var(--ss-ink-soft)] mt-3">{SITE.hours}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div id="enquiry-form" className="bg-[var(--ss-cream)] rounded-3xl p-8 md:p-10 border border-[var(--ss-gold)]/30">
              <div className="font-serif text-3xl md:text-4xl text-[var(--ss-teal-800)]">
                Request a free callback
              </div>
              <p className="text-[var(--ss-ink-soft)] mt-2">
                Quick form — name, phone, email, postcode and a few words about what's
                going on. We'll do the rest.
              </p>
              <div className="mt-6">
                <EnquiryForm sourcePage="contact-page" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
